import { render, staticRenderFns } from "./DownloadXML.vue?vue&type=template&id=30981d66"
import script from "./DownloadXML.vue?vue&type=script&lang=js"
export * from "./DownloadXML.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30981d66')) {
      api.createRecord('30981d66', component.options)
    } else {
      api.reload('30981d66', component.options)
    }
    module.hot.accept("./DownloadXML.vue?vue&type=template&id=30981d66", function () {
      api.rerender('30981d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/DownloadXML.vue"
export default component.exports